import type { Filter } from './filters'

export function getListingFilterQuery(filters: Filter[]): URLSearchParams {
  const parameters = new URLSearchParams()
  for (const filter of filters) {
    if (filter.enabled && filter.value !== undefined && (filter.name === 'sort' || filter.name === 'premium')) {
      parameters.set(filter.name, String(filter.value))
    }
  }
  return parameters
}

export function withListingFilters(href: string, filters: Filter[]): string {
  const [path, hash] = href.split('#', 2)
  const [pathname, query] = path.split('?', 2)
  const parameters = new URLSearchParams(query)
  for (const [name, value] of getListingFilterQuery(filters)) {
    if (!parameters.has(name)) parameters.set(name, value)
  }
  const search = parameters.toString()
  return `${pathname}${search ? `?${search}` : ''}${hash === undefined ? '' : `#${hash}`}`
}
